import {NgModule} from '@angular/core';
import {CertificateComponent} from './certificate/certificate.component';
import {CertificateDetailComponent} from './certificate/certificate-detail/certificate-detail.component';
import {PagesContainerComponent} from './pages-container/pages-container.component';
import {provideRouter, RouterModule, Routes, withComponentInputBinding} from '@angular/router';
import {SharedModule} from '../../core/modules/shared.module';
import {UsersComponent} from './users/users.component';
import {FrontUsersComponent} from './frontend-users/frontusers.component';
import {BottomSheetOverviewExampleSheet , CommunicationsComponent} from './communications/communications.component';
import {BlogComponent} from './blog/blog.component';
import {CantonComponent} from './canton/canton.component';
import {StatisticComponent} from './statistic/statistic.component';
import {AuthGuard} from '../../guards/auth.guard';
import {OrganizerSettingsComponent} from './settings/organizer-settings/organizer-settings.component';
import {ConfessionComponent} from './settings/confession/confession.component';
import {TagComponent} from './settings/tag/tag.component';
import {EventSettingsComponent} from './settings/event-settings/event-settings.component';
import {AreasSettingsComponent} from './settings/areas-settings/areas-settings.component';
import {CreditsSystemSettingsComponent} from './settings/credits-system-settings/credits-system-settings.component';
import {AdminUsersSettingsComponent} from './settings/admin-users-settings/admin-users-settings.component';
import {DocumentsComponent} from './manager/documents/documents.component';
import {TasksComponent} from './manager/tasks/tasks.component';
import {PicturesComponent} from './manager/pictures/pictures.component';
import {ProfileComponent} from './profile/profile.component';
import {CantonNewComponent} from './canton/canton-new/canton-new.component';
import { NG_VALIDATORS, ReactiveFormsModule } from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CantonsService} from '../../core/services/cantons.service';
import {UserService} from '../../core/services/users.service';
import {OrganizationsService} from '../../core/services/organizations.service';
import {ConfessionService} from '../../core/services/confession.service';
import {TagService} from '../../core/services/tag.service';
import {OrganizationComponent} from './organization/organization.component';
import {CantonDetailComponent} from './canton/canton-detail/canton-detail.component';
import {OrganizationTypeService} from '../../core/services/organizationType.service';
import {EventService} from '../../core/services/event.service';
import {EventTypeService} from '../../core/services/eventType.service';
import {OrganizationNewComponent} from './organization/organization-new/organization-new.component';
import {UserNewComponent} from './users/user-new/user-new.component';
import {FrontUserNewComponent} from './frontend-users/frontuser-new/frontuser-new.component';
import {
  DialogVerifyDialog ,
  FrontUserDetailComponent
} from './frontend-users/frontuser-detail/frontuser-detail.component';
import {UserDetailComponent} from './users/user-detail/user-detail.component';
import {OrganizationDetailComponent} from './organization/organization-detail/organization-detail.component';
import {SettingFormDialogComponent} from './settings/organizer-settings/setting-form/setting-form.component';
import {FunctionFormDialogComponent} from './settings/function-settings/setting-form/setting-form.component';
import {BlogTypeFormDialogComponent} from './settings/blogType-settings/setting-form/setting-form.component';
import {EventTypeFormDialogComponent} from './settings/event-settings/setting-form/setting-form.component';
import {FrontUserFormDialogComponent} from './frontend-users/frontuser-detail/setting-form/setting-form.component';
import {NoAccessPageComponent} from './no-access-page/no-access-page';
import {DocumentTabComponent} from './events/event-tabs/document-tab';
import {PictureService} from '../../core/services/picture.service';
import {BlogService} from '../../core/services/blog.service';
import {PictureFormDialogComponent} from './manager/pictures/setting-form/setting-form.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {LevelSettingsComponent} from './settings/level-settings/level-settings.component';
import {LevelService} from '../../core/services/level.service';
import {LevelFormDialogComponent} from './settings/level-settings/setting-form/setting-form.component';
import {TargetGroupFormDialogComponent} from './settings/target-group/setting-form/setting-form.component';
import {SubCreditTargetFormDialogComponent} from './settings/target-group/target-group-setting/setting-form/setting-form.component';
import {ConfessionFormDialogComponent} from './settings/confession/setting-form/setting-form.component';
import {DynamicDataFormDialogComponent} from './settings/dynamicData/setting-form/setting-form.component';
import {CommunicationFormDialogComponent} from './communications/setting-form/setting-form.component';
import {
  CommunicationCopyFormDialogComponent ,
  DialogName
} from './communications/setting-form-copy/setting-form.component';
import {TagFormDialogComponent} from './settings/tag/setting-form/setting-form.component';
import {TargetGroupComponent} from './settings/target-group/target-group.component';
import {TargetGroupSettingComponent} from './settings/target-group/target-group-setting/target-group-setting.component';
import {TutorialFormDialogComponent} from './tutorial/setting-form/setting-form.component';
import {TargetGroupService} from '../../core/services/targetGroup.service';
import {DocumentsService} from '../../core/services/documents.service';
import {LoaderService} from '../../core/services/loader.service';
import {
  checkEmailOnServer, emailValidator, numberValidator,
  websiteValidator
} from '../../core/validators/validators';
import { NgxSpinnerModule } from 'ngx-spinner';
import {TargetGroupSettingService} from '../../core/services/targetGroupSetting.service';
import {SubCreditTargetService} from '../../core/services/subCreditTarget.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CheckModalComponent } from './check-save-modal/check-modal';
import { PictureModalComponent } from './pictures-modal/picture-modal';
import {FrontUserService} from '../../core/services/frontUsers.service';
import { CanDeactivateGuard } from '../../core/services/can-deactivate-guard.service';
import { FilterMenuComponent } from '../../core/components/filter-menu/filter-menu';
import { NewCropperComponent } from '../../core/components/new-cropper/cropper';
import { FuseDeleteDialogComponent } from '../../core/components/delete-dialog/delete-dialog.component';
import { FuseMailDialogComponent } from '../../core/components/mail-dialog/mail-dialog.component';
import { RewardsComponent } from './frontend-users/frontuser-detail/rewards/rewards';
import { EventListComponent } from './frontend-users/frontuser-detail/eventList/eventList';
import { ProgramComponent } from './frontend-users/frontuser-detail/program_block/program.component';
import { BlogNewComponent } from './blog/blog-new/blog-new';
import { BlogDetailComponent } from './blog/blog-detail/blog-detail';
import { BlogBlockComponent } from './blog/blog-block/blog-block.component';
import { EmailBilderComponent } from './settings/emailBilder/email-bilder.component';
import { EditWidgetComponent } from '../../core/components/view-email-builder/edit-widget/edit-widget.component';
import { ImportJsonDialogComponent } from '../../core/components/view-email-builder/import-json-dialog/import-json-dialog.component';
import { SimpleDialogComponent } from '../../core/components/view-email-builder/simple-dialog/simple-dialog.component';
import { WidgetsService } from '../../core/components/view-email-builder/widgets.service';
import { EventDescriptionComponent } from './events/event-block/event-description.component';
import { DiagramComponent } from './frontend-users/diagram/diagram.component';
import { SimpleCardComponent } from './statistic/simple-card/simple-card';
import { SimpleTreeComponent } from './statistic/simple-tree/simple-tree';
import { SimpleBarComponent } from './statistic/simple-bar/simple-bar';
import { TimeLineComponent } from './frontend-users/time-line/time-line.component';
import { ChartsModule } from 'angular-bootstrap-md';
import { NewBlogComponent } from './blog/custom-blog/new-blog.component';
import { HeaderOneComponent } from './blog/header_1/header_1.component';
import { RewardsModalComponent } from './frontend-users/addRewards/rewards';
import { EventCantonsComponent } from './settings/event-cantons/event-cantons.component';
import { FunctionSettingsComponent } from './settings/function-settings/function-settings.component';
import { ReleasedEventComponent } from './released-event/released-event.component';
import { EventAndRewardsComponent } from './frontend-users/frontuser-detail/eventAndRewards/eventAndRewards';
import { ImportUserComponent } from './frontend-users/importUser/importUser.component';
import { BookEventComponent } from './frontend-users/bookEvent/book-event.component';
import {AddCreditsComponent} from './events/add-credits/add-credits.component';
import {CommunicationService} from '../../core/services/communication.service';
import {TutorialComponent} from './tutorial/tutorial.component';
import { QuillModule } from 'ngx-quill';
import localeDe from '@angular/common/locales/de';
import {registerLocaleData} from '@angular/common';
import {GroupComponent} from './settings/group/group.component';
import {GroupService} from '../../core/services/group.service';
import {GroupFormDialogComponent} from './settings/group/setting-form/setting-form.component';
import {TemplatesService} from '../../core/services/templates.service';
import {TemplatesComponent} from './communications/templates.component';
import {LinkHttpPipe} from '../../core/pipes/href.pipe';
import {DynamicDataComponent} from './settings/dynamicData/dynamicData.component';
import {DynamicDataService} from '../../core/services/dynamicData.service';
import {DynamicDataOrgFormDialogComponent} from './organization/organization-detail/setting-form/setting-form.component';
import {PrivacyFormDialogComponent} from './organization/organization-detail/setting-dialog/setting-form.component';
import {PreviewFormDialogComponent} from './organization/organization-detail/preview-dialog/setting-form.component';
import {FuncionTypeService} from '../../core/services/functionType.service';
import {FrontUsersNoActiveComponent} from './frontend-users/frontusersnoactive.component';
import {FrontUserNoActiveService} from '../../core/services/frontUsersNoActive.service';
import {
  TGDialog , TransferDialog ,
  WizzardDialogComponent
} from './organization/organization-detail/wizzard-dialog/setting-form.component';
import {DefaultComponent} from './settings/default/default.component';
import {DefaultFormDialogComponent} from './settings/default/setting-form/setting-form.component';
import {
  EventDialog ,
  EventDialogComponent
} from './organization/organization-detail/event-dialog/setting-form.component';
import {
  UserDialog ,
  UserDialogComponent
} from './organization/organization-detail/user-dialog/setting-form.component';
import {SimplePieComponent} from './statistic/simple-pie/simple-pie';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import {SimpleListComponent} from './statistic/simple-list/simple-list';
import {BlogTypeSettingsComponent} from './settings/blogType-settings/blogType-settings.component';
import {BlogTypeService} from '../../core/services/blogType.service';
import { WhatsappComponent } from './manager/WhatsApp/whatsapp.component';
import { BudgetComponent } from './manager/budget/budget.component';
import { PersonnelComponent } from './manager/personnel/personnel.component';
import { MaterialModule } from '../../core/modules/material.module';
import {ProjectSetComponent} from './settings/project-settings/project-set.component';
import {LogsService} from '../../core/services/logs.service';
import {LogsComponent} from './manager/logs/logs.component';
import {EmailEditorComponent} from './settings/emailEditor/emailEditor.component';
import {NewsComponent} from './news/news.component';
import {GuestEventComponent} from './events/guestEventModal/guestEvent.component';
import {DynamicFormsComponent} from './dynamic_forms/dynamic_forms.component';
import {NewFormsComponent} from './dynamic_forms/new_dyn_forms/new_forms.component';
import {EditGuestData} from './events/edit-guest-data/editGuestData';
import {RewardsToAll} from './frontend-users/addRewardsToAll/rewardsToAll';
import {GenderFuncService} from '../../core/services/genderFunc.service';
import {AdditionalFrontUserInfoService} from '../../core/services/additionalFrontUserInfo.service';
import {GenderTypeComponent} from './settings/genderType/genderType.component';
import {GenderTypeDialogComponent} from './settings/genderType/setting-form/setting-form.component';
import {RelativesComponent} from './frontend-users/frontuser-detail/relatives/relatives.component';
import {AddConnection} from './frontend-users/frontuser-detail/addConnectionModal/addConnection';
import {CheckRoleModalComponent} from './frontend-users/frontuser-detail/checkModal/check-modal.component';
import {UploaderComponent} from '../../core/components/big-file-uploader/uploader.component';
import {ELearningService} from '../../core/services/e-learning.service';
import {ELearningComponent} from './e-learning/e-learning.component';
import {ElDetailComponent} from './e-learning/detail/el-detail.component';
import {DocumentUploaderComponent} from '../../core/components/document-uploader/document-uploader.component';
import {NewCreditTargetComponent} from './settings/target-group/target-group-setting/new-credit-target/newCreditTarget.component';
import {FileUploaderComponent} from '../../core/components/file-uploader/file-uploader.component';
import {FileUploaderService} from '../../core/services/file-uploader.service';
import {PlatformsComponent} from './settings/platforms/platforms.component';
import {PlatformsService} from '../../core/services/platforms.service';
import {PlatformDetailComponent} from './settings/platforms/detail/platform-detail.component';
import {MatrixPlatformsComponent} from './matrix/platform/matrixPlatforms.component';
import {EditPlatformModal} from './matrix/platform/edit-platform/edit-platform.modal';
import {ModulesService} from '../../core/services/modules.service';
import {ModulesComponent} from './settings/modules/modules.component';
import {ModuleDetailComponent} from './settings/modules/detail/module-detail.component';
import {OrgPlatformsComponent} from './marketplace/platforms/org-platforms.component';
import {MatrixModuleComponent} from './matrix/module/module.component';
import {EditModuleModal} from './matrix/module/edit-module/edit-module.modal';
import {OrgModulesComponent} from './marketplace/modules/org-modules.component';
import {SpaceService} from '../../core/services/space.service';
import {SpacesComponent} from './settings/spaces/spaces.component';
import {EditSpaceModal} from './settings/spaces/edit-modal/edit-space.modal';
import {NewSpaceComponent} from './settings/spaces/new/new-space.component';
import {LearnCategoryService} from '../../core/services/learnCategory.service';
import {LearnCategoryComponent} from './settings/learnCategory/learnCategory.component';
import {EditLearnCategoryComponent} from './settings/learnCategory/setting-form/edit-learn-category.component';
import { ShareLinksComponent } from './settings/share-links/shareLinks.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { DeleteRequestComponent } from './delete-request/delete-request.component';
import { PhoneMaskDirective } from '../../core/directives/phone-mask/phone-mask.directive';
import { OpenPictureModalComponent } from './manager/pictures/open-pictures/open-pictures.modal';
import { NgxQrcodeStylingComponent } from 'ngx-qrcode-styling';
import { RecommendEvents } from './recommend/events/recommend-events.component';
import { RecommendedEventModal } from './events/recommend-event-modal/recommend-event.component';
import { EditRecommendationComponent } from './recommend/edit-recommendation/edit-recommendation.component';
import { RecommendBlogs } from './recommend/blogs/recommend-blogs.component';
import { RecommendElearnings } from './recommend/elearnings/recommend-elearnings.component';
import { ElearningPreview } from './e-learning/preview/elearning-preview.component';
import { ElearningDetailComponent } from './e-learning/elearning-detail/elearning-detail.component';
import { RecommendationEventComponent } from './recommendation/events/recommendation-events.component';
import { RecommendationService } from '../../core/services/recommendation.service';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { RecommendedEventComponent } from './recommendation/recommended-event/recommended-event.component';
import { RecommendationDetailModal } from './recommendation/recommendation-detail-modal/recommendation-detail.modal';
import { RecommendationBlogsComponent } from './recommendation/blogs/recommendation-blogs.component';
import { RecommendedBlogComponent } from './recommendation/recommended-blog/recommended-blog.component';
import { RecommendationElearningsComponent } from './recommendation/elearnings/recommendation-elearnings.component';
import { SubscriptionService } from '../../core/services/subscription.service';
import { RecommendedElearningComponent } from './recommendation/recommended-elearning/recommended-elearning.component';
import { FavoriteComponent } from './recommendation/favorite/favorite.component';
import { SubEventParticipantComponent } from './events/sub-event-participant/sub-event-participant.component';
import { SubEventParticipantModalComponent } from './events/sub-event-participant-modal/sub-event-participant.modal';
import { AddPictureComponent } from './e-learning/add-picture-modal/add-picture.component';
import { MarketplaceComponent } from './marketplaces/marketplace.component';
import { MarketplaceCategoryService } from '../../core/services/marketplaceCategory.service';
import { MarketplaceCategoriesComponent } from './settings/marketplace-categories/marketplace-categories.component';
import {
  EditMarketplaceCategoryModal
} from './settings/marketplace-categories/edit-modal/edit-marketplace-category.modal';
import { NewMarCatComponent } from './settings/marketplace-categories/new/new-mar-cat.component';
import {MarketplaceDetailComponent} from './marketplaces/detail/marketplace-detail.component';
import {MarketplaceService} from '../../core/services/marketplace.service';
import {MailTemplateService} from '../../core/services/mailTemplate.service';
import {CertificateTemplateService} from '../../core/services/certificateTemplate.service';
import { LearningPathsComponent } from './learning-paths/learning-paths.component';
import { LearningPathDetailComponent } from './learning-paths/detail/learning-path-detail.component';
import {CreditCorrectionAllComponent} from './frontend-users/creditCorrectionAll/credit-correction-all.component';
import {LearningPathsService} from '../../core/services/learningPaths.service';
import {HubOverviewService} from '../../core/services/hubOverview.service';
import {AddContentModalComponent} from './learning-paths/addContentModal/add-content-modal.component';
import {EditParishOrgsComponent} from './learning-paths/editParishOrgs/edit-parish-orgs.component';
import {LearningPathParticipantComponent} from './learning-paths/learningPathParticipant/learning-path-participant.component';
import {ELearningParticipantComponent} from './e-learning/elearningParticipant/elearning-participant.component';
import {CompetencyComponent} from './competency/competency.component';
import {CompetencyDetailComponent} from './competency/detail/competency-detail.component';
import {OrgCompetencyComponent} from './settings/org-competency/org-competency.component';
import {EventComponent} from './events-ref/event.component';
import {HubOverviewComponent} from './hubOverview/hub-overview.component';
import {EventDetailRefComponent} from './events-ref/event-detail/event-detail.component';
import {CalendarRefComponent} from './calendar-ref/calendar-ref.component';
import {ParishOrganizationComponent} from './settings/parishOrganization/parishOrganization.component';
import {ParishOrganizationDetailComponent} from './settings/parishOrganization/parishOrganization-detail/parishOrganization-detail.component';
import {AdditionalFrontUserInfoComponent} from './settings/additionalFrontUserInfo/additionalFrontUserInfo.component';
import {AdditionalFrontUserInfoFormDialogComponent} from './settings/additionalFrontUserInfo/setting-form/setting-form.component';
import {BannerComponent} from './forum-talk/banner/banner.component';
import {ForumNewsComponent} from './forum-talk/news/news.component';
import {StatisticsComponent} from './forum-talk/statistics/statistics.component';
import {SystemTextComponent} from './forum-talk/system-text/system-text.component';
import {ChatSettingComponent} from '../../core/components/chat-setting/chat-setting.component';
import {CertificateSettingComponent} from '../../core/components/certificate-setting/certificate-setting.component';
import {TaskGroupComponent} from './settings/taskGroup/taskGroup.component';
import {TasksComponent as TasksPageComponent} from './tasks/tasks.component';
import {TaskFormComponent} from './tasks/task-form/task-form.component';
import {TaskGroupService} from '../../core/services/taskGroup.service';
import {FrontUserTaskService} from '../../core/services/frontUserTask.service';
import {RejectTaskDialogComponent} from './frontend-users/frontuser-detail/reject-task-dialog/reject-task-dialog.component';
import {AddTaskModalComponent} from './frontend-users/frontuser-detail/add-task-modal/add-task-modal.component';
import {DocumentComponent} from '../../core/components/document/document.component';

registerLocaleData(localeDe);

const routes: Routes = [
  {
    path: 'pages/hubOverview' ,
    component: HubOverviewComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/canton' ,
    component: CantonComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: CantonsService
    }
  } ,
  {
    path: 'pages/organization' ,
    component: OrganizationComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: OrganizationsService
    }
  } ,
  {
    path: 'pages/canton/new' ,
    component: CantonNewComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  {
    path: 'pages/organization/new' ,
    component: OrganizationNewComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  {
    path: 'pages/organization/detail' ,
    component: OrganizationDetailComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  {
    path: 'pages/canton/detail' ,
    component: CantonDetailComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  // refactoring event
  {
    path: 'pages/event' ,
    component: EventComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/event/detail' ,
    component: EventDetailRefComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  {
    path: 'pages/events/:status' ,
    component: EventComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  {
    path: 'pages/released-event' ,
    component: ReleasedEventComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/marketplaces' ,
    component: MarketplaceComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/marketplaces/detail' ,
    component: MarketplaceDetailComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  {
    path: 'pages/learningPaths' ,
    component: LearningPathsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/learningPaths/detail' ,
    component: LearningPathDetailComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  {
    path: 'pages/users' ,
    component: UsersComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/frontusers' ,
    component: FrontUsersComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: FrontUserService
    }
  } ,
  {
    path: 'pages/delete-request' ,
    component: DeleteRequestComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: FrontUserService
    }
  } ,
  {
    path: 'pages/frontusersnoactive' ,
    component: FrontUsersNoActiveComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: FrontUserNoActiveService
    }
  } ,
  {
    path: 'pages/user/new' ,
    component: UserNewComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  {
    path: 'pages/frontUser/new' ,
    component: FrontUserNewComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/frontusers/detail' ,
    component: FrontUserDetailComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/frontusersnoactive/detail' ,
    component: FrontUserDetailComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/user/detail' ,
    component: UserDetailComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  {
    path: 'pages/recommendation/recommendation-event' ,
    component: RecommendationEventComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/recommendation/favorite' ,
    component: FavoriteComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/recommendation/recommendation-elearning' ,
    component: RecommendationElearningsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/recommendation/recommendation-blog' ,
    component: RecommendationBlogsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/communications' ,
    component: CommunicationsComponent ,
    canActivate: [ AuthGuard ],
  } ,
  {
    path: 'pages/certificate' ,
    component: CertificateComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/certificate/new' ,
    component: CertificateDetailComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/certificate/detail' ,
    component: CertificateDetailComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/recommendEvent' ,
    component: RecommendEvents ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/recommendElearning' ,
    component: RecommendElearnings ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/recommendBlog' ,
    component: RecommendBlogs ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/dynamicForm' ,
    component: DynamicFormsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/dynamicForm/new' ,
    component: NewFormsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/news' ,
    component: NewsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/templates' ,
    component: TemplatesComponent ,
    canActivate: [ AuthGuard ],
    resolve: {
      data: TemplatesService
    }
  } ,
  {
    path: 'pages/forumBanner' ,
    component: BannerComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/forumNews' ,
    component: ForumNewsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/forumStatistics' ,
    component: StatisticsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/forumSystemText' ,
    component: SystemTextComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/organizer-settings' ,
    component: OrganizerSettingsComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: OrganizationTypeService
    }
  } ,
  {
    path: 'pages/settings/confession' ,
    component: ConfessionComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: ConfessionService
    }
  } ,
  {
    path: 'pages/settings/dynamicData' ,
    component: DynamicDataComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: DynamicDataService
    }
  } ,
  {
    path: 'pages/settings/group' ,
    component: GroupComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: GroupService
    }
  } ,
  {
    path: 'pages/settings/default' ,
    component: DefaultComponent ,
    canActivate: [ AuthGuard ] ,
  } ,
  {
    path: 'pages/settings/parishOrganization' ,
    component: ParishOrganizationComponent ,
    canActivate: [ AuthGuard ] ,
  } ,
  {
    path: 'pages/settings/parishOrganization/detail' ,
    component: ParishOrganizationDetailComponent ,
    canActivate: [ AuthGuard ] ,
  } ,
  {
    path: 'pages/settings/additionalFrontUserInfo' ,
    component: AdditionalFrontUserInfoComponent ,
    canActivate: [ AuthGuard ] ,
  } ,
  {
    path: 'pages/settings/competency' ,
    component: CompetencyComponent ,
    canActivate: [ AuthGuard ] ,
  } ,
  {
    path: 'pages/settings/competency/new' ,
    component: CompetencyDetailComponent ,
    canActivate: [ AuthGuard ] ,
    canDeactivate: [CanDeactivateGuard]
  } ,
  // {
  //   path: 'pages/settings/taskGroup' ,
  //   component: TaskGroupComponent ,
  //   canActivate: [ AuthGuard ] ,
  // } ,
  // {
  //   path: 'pages/settings/task/new' ,
  //   component: CompetencyDetailComponent ,
  //   canActivate: [ AuthGuard ] ,
  //   canDeactivate: [CanDeactivateGuard]
  // } ,
  {
    path: 'pages/settings/orgCompetency' ,
    component: OrgCompetencyComponent ,
    canActivate: [ AuthGuard ] ,
  } ,
  {
    path: 'pages/settings/tag' ,
    component: TagComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: TagService
    }
  }, {
    path: 'pages/settings/event-settings' ,
    component: EventSettingsComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: EventTypeService
    }
  }
  , {
    path: 'pages/settings/level-settings' ,
    component: LevelSettingsComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: LevelService
    }
  } ,
  {
    path: 'pages/settings/target-group' ,
    component: TargetGroupComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/target-group-setting' ,
    component: TargetGroupSettingComponent ,
  } ,
  {
    path: 'pages/tutorial' ,
    component: TutorialComponent ,
  } ,
  {
    path: 'pages/eLearning' ,
    component: ELearningComponent ,
  },
  {
    path: 'pages/eLearning/preview' ,
    component: ElearningPreview ,
  },
  {
    path: 'pages/eLearning/detail' ,
    component: ElDetailComponent ,
  },
  {
    path: 'pages/marketplace/org-platform',
    component: OrgPlatformsComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'pages/marketplace/org-modules',
    component: OrgModulesComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'pages/settings/admin-users-settings' ,
    component: AdminUsersSettingsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/modules' ,
    component: ModulesComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/modules/detail' ,
    component: ModuleDetailComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/platforms' ,
    component: PlatformsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/platforms/detail' ,
    component: PlatformDetailComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/areas-settings' ,
    component: AreasSettingsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/credits-system-settings' ,
    component: CreditsSystemSettingsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/learn-category' ,
    component: LearnCategoryComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/share-links' ,
    component: ShareLinksComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/marketplaceCategory' ,
    component: MarketplaceCategoriesComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/marketplaceCategory/new' ,
    component: NewMarCatComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/spaces' ,
    component: SpacesComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/spaces/new' ,
    component: NewSpaceComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/email-builder' ,
    component: EmailBilderComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/event-cantons' ,
    component: EventCantonsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/settings/function' ,
    component: FunctionSettingsComponent ,
    canActivate: [ AuthGuard ],
    resolve: {
      data: FuncionTypeService
    }
  } ,
  {
    path: 'pages/settings/blogType' ,
    component: BlogTypeSettingsComponent ,
    canActivate: [ AuthGuard ],
    resolve: {
      data: BlogTypeService
    }
  } ,
  {
    path: 'pages/settings/projectSettings' ,
    component: ProjectSetComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/matrix/platforms' ,
    component: MatrixPlatformsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/matrix/mat-modules' ,
    component: MatrixModuleComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/blog' ,
    component: BlogComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/blog/detail' ,
    component: BlogDetailComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  {
    path: 'pages/blog/new' ,
    component: BlogNewComponent ,
    canActivate: [ AuthGuard ] ,
    canDeactivate: [ CanDeactivateGuard ]
  },
  {
    path: 'pages/statistic' ,
    component: StatisticComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/manager/tasks' ,
    component: TasksComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/tasks' ,
    component: TaskGroupComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/tasks/detail' ,
    component: TaskFormComponent ,
    canActivate: [ AuthGuard ],
    canDeactivate: [CanDeactivateGuard]
  } ,
  {
    path: 'pages/manager/documents' ,
    component: DocumentsComponent ,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'pages/manager/whatsapp' ,
    component: WhatsappComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/manager/budget' ,
    component: BudgetComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/manager/logsHistory' ,
    component: LogsComponent ,
    canActivate: [ AuthGuard ]
  } ,
  // {
  //   path: 'pages/settings/emailEditor' ,
  //   component: EmailEditorComponent ,
  //   canActivate: [ AuthGuard ]
  // } ,
  {
    path: 'pages/settings/genderType' ,
    component: GenderTypeComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/manager/personnel' ,
    component: PersonnelComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/manager/pictures' ,
    component: PicturesComponent ,
    canActivate: [ AuthGuard ] ,
    resolve: {
      data: PictureService
    }
  }
  ,
  {
    path: 'pages/profile' ,
    component: ProfileComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: 'pages/calendar' ,
    component: CalendarRefComponent ,
    canActivate: [ AuthGuard ]
  } ,
  {
    path: '*' ,
    component: NoAccessPageComponent
  }
];

@NgModule({
    imports: [
        PagesContainerComponent,
        SharedModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        PdfViewerModule,
        NgxChartsModule,
        QuillModule,
        NgxSpinnerModule,
        ChartsModule,
        NgSelectModule,
        NgxDaterangepickerMd.forRoot(),
        MaterialModule,
        EditorModule,
        NgxQrcodeStylingComponent,
        ImageCropperComponent,
        EditParishOrgsComponent,
        ChatSettingComponent,
        CertificateSettingComponent,
        DocumentComponent
    ],
  declarations: [
    CertificateComponent,
    CertificateDetailComponent,
    UsersComponent,
    FrontUsersComponent,
    FrontUsersNoActiveComponent,
    CommunicationsComponent,
    TemplatesComponent,
    OrganizerSettingsComponent,
    ConfessionComponent,
    DynamicDataComponent,
    GroupComponent,
    DefaultComponent,
    TagComponent,
    EventSettingsComponent,
    AdminUsersSettingsComponent,
    AreasSettingsComponent,
    CreditsSystemSettingsComponent,
    BlogComponent,
    StatisticComponent,
    DocumentsComponent,
    TasksComponent,
    PicturesComponent,
    CantonComponent,
    ProfileComponent,
    CantonNewComponent,
    CantonDetailComponent,
    OrganizationComponent,
    OrganizationNewComponent,
    OrganizationDetailComponent,
    SettingFormDialogComponent,
    DefaultFormDialogComponent,
    EventDialogComponent,
    UserDialogComponent,
    FunctionFormDialogComponent,
    BlogTypeFormDialogComponent,
    DialogName,
    EventTypeFormDialogComponent,
    AdditionalFrontUserInfoFormDialogComponent,
    FrontUserFormDialogComponent,
    DynamicDataOrgFormDialogComponent,
    WizzardDialogComponent,
    PreviewFormDialogComponent,
    PrivacyFormDialogComponent,
    UserNewComponent,
    FrontUserNewComponent,
    FrontUserDetailComponent,
    UserDetailComponent,
    NoAccessPageComponent,
    DocumentTabComponent,
    PictureFormDialogComponent,
    LevelSettingsComponent,
    LevelFormDialogComponent,
    TargetGroupFormDialogComponent,
    TGDialog,
    EventDialog,
    UserDialog,
    TransferDialog,
    TargetGroupComponent,
    FilterMenuComponent,
    SubCreditTargetFormDialogComponent,
    ConfessionFormDialogComponent,
    DynamicDataFormDialogComponent,
    GroupFormDialogComponent,
    CommunicationFormDialogComponent,
    BottomSheetOverviewExampleSheet,
    TutorialFormDialogComponent,
    CommunicationCopyFormDialogComponent,
    TagFormDialogComponent,
    TargetGroupComponent,
    TargetGroupSettingComponent,
    TutorialComponent,
    CheckModalComponent,
    PictureModalComponent,
    NewCropperComponent,
    FuseDeleteDialogComponent,
    FuseMailDialogComponent,
    DialogVerifyDialog,
    RejectTaskDialogComponent,
    AddTaskModalComponent,
    EventListComponent,
    ProgramComponent,
    RewardsComponent,
    BlogNewComponent,
    BlogDetailComponent,
    BlogBlockComponent,
    EmailBilderComponent,
    EditWidgetComponent,
    ImportJsonDialogComponent,
    SimpleDialogComponent,
    EventDescriptionComponent,
    DiagramComponent,
    SimpleCardComponent,
    SimpleTreeComponent,
    SimpleBarComponent,
    SimpleListComponent,
    SimplePieComponent,
    TimeLineComponent,
    NewBlogComponent,
    HeaderOneComponent,
    RewardsModalComponent,
    EventCantonsComponent,
    FunctionSettingsComponent,
    BlogTypeSettingsComponent,
    ReleasedEventComponent,
    EventAndRewardsComponent,
    ImportUserComponent,
    BookEventComponent,
    AddCreditsComponent,
    LinkHttpPipe,
    WhatsappComponent,
    BudgetComponent,
    PersonnelComponent,
    ProjectSetComponent,
    LogsComponent,
    EmailEditorComponent,
    NewsComponent,
    GuestEventComponent,
    DynamicFormsComponent,
    NewFormsComponent,
    EditGuestData,
    RewardsToAll,
    GenderTypeComponent,
    GenderTypeDialogComponent,
    RelativesComponent,
    AddConnection,
    CheckRoleModalComponent,
    UploaderComponent,
    ELearningComponent,
    ElDetailComponent,
    DocumentUploaderComponent,
    NewCreditTargetComponent,
    FileUploaderComponent,
    PlatformsComponent,
    PlatformDetailComponent,
    MatrixPlatformsComponent,
    EditPlatformModal,
    ModulesComponent,
    ModuleDetailComponent,
    OrgPlatformsComponent,
    MatrixModuleComponent,
    EditModuleModal,
    OrgModulesComponent,
    SpacesComponent,
    EditSpaceModal,
    NewSpaceComponent,
    LearnCategoryComponent,
    EditLearnCategoryComponent,
    ShareLinksComponent,
    DeleteRequestComponent,
    PhoneMaskDirective,
    OpenPictureModalComponent,
    RecommendEvents,
    RecommendedEventModal,
    EditRecommendationComponent,
    RecommendBlogs,
    RecommendElearnings,
    ElearningPreview,
    ElearningDetailComponent,
    RecommendationEventComponent,
    RecommendedEventComponent,
    RecommendationDetailModal,
    RecommendationBlogsComponent,
    RecommendedBlogComponent,
    RecommendationElearningsComponent,
    RecommendedElearningComponent,
    FavoriteComponent,
    SubEventParticipantComponent,
    SubEventParticipantModalComponent,
    AddPictureComponent,
    MarketplaceComponent,
    MarketplaceCategoriesComponent,
    EditMarketplaceCategoryModal,
    NewMarCatComponent,
    MarketplaceDetailComponent,
    LearningPathsComponent,
    LearningPathDetailComponent,
    CreditCorrectionAllComponent,
    AddContentModalComponent,
    LearningPathParticipantComponent,
    ELearningParticipantComponent
  ],
  exports: [
    LinkHttpPipe
  ],
  providers: [
    CantonsService,
    UserService,
    FrontUserService,
    FrontUserNoActiveService,
    CommunicationService,
    TemplatesService,
    OrganizationTypeService,
    OrganizationsService,
    ConfessionService,
    DynamicDataService,
    GroupService,
    TagService,
    EventTypeService,
    PictureService,
    BlogService,
    EventService,
    LevelService,
    TargetGroupService,
    FuncionTypeService,
    BlogTypeService,
    DocumentsService,
    LoaderService,
    TargetGroupSettingService,
    SubCreditTargetService,
    WidgetsService,
    LogsService,
    GenderFuncService,
    AdditionalFrontUserInfoService,
    {provide: NG_VALIDATORS, useValue: numberValidator, multi: true},
    {provide: NG_VALIDATORS, useValue: websiteValidator, multi: true},
    {provide: NG_VALIDATORS, useValue: emailValidator, multi: true},
    {provide: NG_VALIDATORS, useValue: checkEmailOnServer, multi: true},
    CanDeactivateGuard,
    ELearningService,
    FileUploaderService,
    PlatformsService,
    ModulesService,
    SpaceService,
    LearnCategoryService,
    RecommendationService,
    SubscriptionService,
    MarketplaceCategoryService,
    MarketplaceService,
    MailTemplateService,
    CertificateTemplateService,
    LearningPathsService,
    HubOverviewService,
    TaskGroupService,
    FrontUserTaskService,
    provideRouter(
      routes,
      withComponentInputBinding()
    )
  ]
})
export class PagesPepperModule {
}
